export default (set, totalPriceData) => set(
  () => ({
    totalPrice: totalPriceData
  }),
  false,
  { type: 'promo/updateTotalPrice', totalPriceData }
);
